export const orderStatusLookup: { [key: string]: number } = {
  Cancelled: 0,
  "Order received": 1,
  Confirmed: 2,
  Production: 3,
  Shipped: 4,
  "Partial delivery": 5,
  Delivered: 6
};
